/**
 * @description
 */

import './sectionCheckboxList.scss';

import React from 'react';

import FormCheckboxList, { IProps, IState } from '../@formCheckboxList/formCheckboxList';

// 这里提供最基础的问卷功能和结构，后续可扩展这个业务基类。
// 但比如考试的问卷与业务强相关，通过继承FormCheckboxList实现一个新组件去做
export default abstract class SectionCheckboxList extends FormCheckboxList<IProps, IState> {
    public render() {
        return (
            <div className="section-item-body">
                {super.render()}
            </div>
        );
    }
}
